import { Switch, Route, Router as WouterRouter } from "wouter";
import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QuoteProvider } from "@/components/QuoteProvider";
import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import PageMetadata from "@/components/PageMetadata";
const ServiceDetail = lazy(() => import("@/pages/ServiceDetail"));
const Catalogue = lazy(() => import("@/pages/Catalogue"));

const queryClient = new QueryClient();

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/catalogue" component={Catalogue} />
      <Route path="/services/:slug" component={ServiceDetail} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App({ ssrPath }: { ssrPath?: string } = {}) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <QuoteProvider>
          <WouterRouter ssrPath={ssrPath} base={import.meta.env.BASE_URL.replace(/\/$/, "")}>
            <PageMetadata />
            <Suspense fallback={<div className="min-h-screen bg-[#0B1F3A]" aria-busy="true" aria-label="Loading page" />}>
              <Router />
            </Suspense>
          </WouterRouter>
          <Toaster />
        </QuoteProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;

